import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util'
import { BMMeetingListingViewModel} from '../../../../models/bm'

@Component
class BMMeetingListItem extends Vue {

  constructor () {
    super()
  }
  @Prop({ default: {}, type: [Object] })
  bmMeeting: BMMeetingListingViewModel;

  mounted () {}

  get lblSetting () {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/reception').default,
      ...require('@/locales/ticket').default
    }
  }
  get coLink (): string {
    return `/bm/${this.bmMeeting.master.id}/meeting/${this.bmMeeting.id}`
  }
  get coBlockName (): string { return this.bmMeeting.master.block.name }
  get coAddress (): string {
    return `${this.bmMeeting.master.block.address.line1} ${this.bmMeeting.master.block.address.line2} ${this.bmMeeting.master.block.address.zip_code} ${this.bmMeeting.master.block.address.city} `
  }
  get coStartEndDate () {
    return this.$t(this.lblSetting.lblTimeFromTo, {
      start: DateTimeHelper.parseTime(this.bmMeeting.date_start),
      end: DateTimeHelper.parseTime(this.bmMeeting.date_end)
    })
  }
  get coCreatedAt (): string {
    return DateTimeHelper.parseDateTimeCalendar(this.bmMeeting.createdAt)
  }
  get coCreatedBy (): string {
    return [this.bmMeeting.creator.firstname || '', this.bmMeeting.creator.lastname || ''].join(' ')
  }
  get coBuildingGoal (): string {
    return DateTimeHelper.parseDate(this.bmMeeting.date_end)
  }
  get coBuildingStart (): string {
    return DateTimeHelper.parseDate(this.bmMeeting.date_start)
  }
  get coReceptionName (): string {
    return this.$t(this.lblSetting.bmMeetingName, {date: DateTimeHelper.parseDate(this.bmMeeting.date_start)}) + ''
  }
}

export default BMMeetingListItem



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-meeting-list-item/index.ts